import { NgRedux } from "@angular-redux/store";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class LogoutWarningSelectors {

    constructor(private ngRedux: NgRedux<Object>) { }

    selectLogoutWarning(): Observable<Boolean> {
        return this.ngRedux.select(["logoutWarning", "logoutWarningVisible"]);
    }

}
